const money = new Intl.NumberFormat("uk-UA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export function formatMoney(value) {
  const number = Number(value);
  if (value == null || value === "" || !Number.isFinite(number)) return "—";
  return `${money.format(number)} грн`;
}
export function discountPercent(price, oldPrice) {
  const current = Number(price);
  const previous = Number(oldPrice);
  if (!Number.isFinite(current) || !Number.isFinite(previous) || current <= 0 || previous <= current) return 0;
  return Math.round((1 - current / previous) * 100);
}
